module.exports = __webpack_public_path__ + "img/BYOCS_MentalHealth.cda1bbfb.jpg";